(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-programme"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Smooth scroll that accounts for a sticky header ---------- */
    function headerOffset() {
      var header = document.querySelector('.shopify-section-header-sticky, sticky-header, .section-header, header');
      if (!header) return 16;
      var pos = getComputedStyle(header).position;
      var stuck = pos === 'sticky' || pos === 'fixed' ||
        (header.parentElement && /sticky|fixed/.test(getComputedStyle(header.parentElement).position));
      return (stuck ? header.getBoundingClientRect().height : 0) + 16;
    }

    function scrollToTarget(target, focusFirst) {
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
      if (!focusFirst) return;
      var field = target.querySelector('.aff__field input') || target.querySelector('.aff__success');
      if (!field) return;
      var done = false;
      var focus = function () { if (done) return; done = true; field.focus({ preventScroll: true }); };
      if ('onscrollend' in window && !reduceMotion) window.addEventListener('scrollend', focus, { once: true });
      setTimeout(focus, reduceMotion ? 0 : 900);
    }

    /* ---------- Stepper ---------- */
    function initStepper(root) {
      var stepper = root.querySelector('[data-aff-stepper]');
      if (!stepper) return;
      var tabs = Array.prototype.slice.call(stepper.querySelectorAll('[data-aff-step-tab]'));
      var panels = Array.prototype.slice.call(stepper.querySelectorAll('[data-aff-step-panel]'));
      var prev = stepper.querySelector('[data-aff-prev]');
      var next = stepper.querySelector('[data-aff-next]');
      var finish = stepper.querySelector('[data-aff-finish]');
      var countEl = stepper.querySelector('[data-aff-step-count]');
      var bar = stepper.querySelector('[data-aff-step-bar]');
      var total = panels.length;
      var current = 0;

      function show(index, focusTab) {
        current = Math.max(0, Math.min(index, total - 1));
        panels.forEach(function (p, i) {
          var on = i === current;
          p.hidden = !on;
          p.classList.toggle('is-entering', on);
        });
        tabs.forEach(function (t, i) {
          var on = i === current;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        if (countEl) countEl.textContent = 'Step ' + (current + 1) + ' of ' + total;
        if (bar) bar.style.width = ((current + 1) / total) * 100 + '%';
        if (prev) prev.disabled = current === 0;
        var last = current === total - 1;
        if (next) next.hidden = last;
        if (finish) finish.hidden = !last;
        if (focusTab) tabs[current].focus();
        if (tabs[current].scrollIntoView && window.innerWidth < 750) {
          tabs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
          if (keys[e.key]) { e.preventDefault(); show((current + keys[e.key] + total) % total, true); }
          else if (e.key === 'Home') { e.preventDefault(); show(0, true); }
          else if (e.key === 'End') { e.preventDefault(); show(total - 1, true); }
        });
      });
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      // Theme editor: selecting a step block shows it
      root.addEventListener('shopify:block:select', function (e) {
        var i = panels.indexOf(e.target);
        if (i > -1) show(i);
      });

      show(0);
    }

    /* ---------- Form ---------- */
    function initForm(root) {
      var form = document.getElementById(root.dataset.formId);
      if (!form || form.querySelector('[data-aff-success-static]')) {
        if (form && form.querySelector('[data-aff-success-static]') && !location.hash) {
          scrollToTarget(document.getElementById(root.dataset.anchor), false);
        }
        return;
      }

      form.noValidate = true;
      var submit = form.querySelector('[data-aff-submit]');
      var submitLabel = form.querySelector('[data-aff-submit-label]');
      var errorsBox = form.querySelector('[data-aff-errors]');
      var tpl = root.querySelector('[data-aff-success-tpl]');
      var sending = false;
      var nativeSubmit = false;

      function fieldError(input) {
        var err = document.getElementById(input.getAttribute('aria-describedby'));
        var ok = input.checkValidity();
        input.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (err) err.textContent = ok ? '' : err.dataset.msg;
        return ok;
      }

      function validate() {
        var firstBad = null;
        form.querySelectorAll('input[required], input[pattern]').forEach(function (input) {
          if (input.value === '' && !input.required) { fieldError(input); return; }
          if (!fieldError(input) && !firstBad) firstBad = input;
        });
        if (firstBad) firstBad.focus();
        return !firstBad;
      }

      form.querySelectorAll('input[required], input[pattern]').forEach(function (input) {
        input.addEventListener('blur', function () { if (input.value !== '' || input.type === 'checkbox') fieldError(input); });
        input.addEventListener('input', function () { if (input.getAttribute('aria-invalid') === 'true') fieldError(input); });
        input.addEventListener('change', function () { if (input.type === 'checkbox') fieldError(input); });
      });

      function setBusy(busy) {
        sending = busy;
        submit.disabled = busy;
        submit.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (submitLabel) {
          if (!submitLabel.dataset.idle) submitLabel.dataset.idle = submitLabel.textContent;
          submitLabel.textContent = busy ? 'Sending...' : submitLabel.dataset.idle;
        }
      }

      function showErrors(html) {
        errorsBox.innerHTML = html || 'Something went wrong. Please try again.';
        errorsBox.hidden = false;
        errorsBox.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      function showSuccess(data) {
        form.innerHTML = '';
        form.appendChild(tpl.content.cloneNode(true));
        var box = form.querySelector('.aff__success');
        if (box) box.focus({ preventScroll: true });

        // Analytics hooks
        var detail = { email: data.email, marketing: data.marketing };
        root.dispatchEvent(new CustomEvent('affiliate:submitted', { bubbles: true, detail: detail }));
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('affiliate_signup', { marketing: data.marketing }); } catch (e) {}
        if (window.dataLayer) window.dataLayer.push({ event: 'affiliate_signup' });
      }

      function value(selector) {
        var el = form.querySelector(selector);
        return el ? el.value.trim() : '';
      }

      /* Optional: also create a tagged customer (only with marketing consent) */
      function createCustomer(data) {
        if (root.dataset.createCustomer !== 'true' || !data.marketing) return Promise.resolve();
        var parts = data.name.split(' ');
        var body = new URLSearchParams();
        body.append('form_type', 'customer');
        body.append('utf8', String.fromCharCode(10003));
        body.append('contact[email]', data.email);
        body.append('contact[first_name]', parts.shift() || '');
        body.append('contact[last_name]', parts.join(' '));
        body.append('contact[tags]', root.dataset.customerTags || 'affiliate-applicant');
        return fetch('/contact#contact_form', { method: 'POST', body: body, credentials: 'same-origin' }).catch(function () {});
      }

      /* Optional: send a copy to a webhook (Google Apps Script, Zapier, Make...) */
      function sendWebhook(data) {
        var url = root.dataset.webhook;
        if (!url) return;
        try {
          fetch(url, {
            method: 'POST',
            mode: 'no-cors',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: JSON.stringify(data)
          }).catch(function () {});
        } catch (e) {}
      }

      form.addEventListener('submit', function (e) {
        if (nativeSubmit) return;
        e.preventDefault();
        if (sending) return;
        errorsBox.hidden = true;
        if (!validate()) return;

        var mkt = form.querySelector('[data-aff-marketing]');
        var data = {
          name: value('[name="contact[name]"]'),
          email: value('[name="contact[email]"]'),
          phone: value('[name="contact[phone]"]'),
          marketing: !!(mkt && mkt.checked),
          page: window.location.href,
          submitted_at: new Date().toISOString()
        };

        // Bots fill the hidden field: pretend it worked, send nothing.
        var hp = form.querySelector('[data-aff-hp]');
        if (hp && hp.value) { showSuccess(data); return; }

        setBusy(true);
        fetch(form.action, {
          method: 'POST',
          body: new URLSearchParams(new FormData(form)),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            // Shopify asked for a captcha: fall back to a normal submit so the shopper can complete it.
            if (/\/challenge/.test(res.url)) {
              nativeSubmit = true;
              form.submit();
              return null;
            }
            return res.text().then(function (html) { return { res: res, html: html }; });
          })
          .then(function (out) {
            if (!out) return;
            var doc = new DOMParser().parseFromString(out.html, 'text/html');
            var returned = doc.getElementById(form.id);
            var errs = returned && returned.querySelector('[data-aff-errors]:not([hidden])');
            var ok = /contact_posted=true/.test(out.res.url) || (returned && returned.querySelector('[data-aff-success-static]'));

            if (ok || (out.res.ok && !errs)) {
              sendWebhook(data);
              return createCustomer(data).then(function () { showSuccess(data); });
            }
            setBusy(false);
            showErrors(errs ? errs.innerHTML : null);
          })
          .catch(function () {
            setBusy(false);
            showErrors('We could not send your application. Please check your connection and try again.');
          });
      });
    }

    /* ---------- CTA scroll ---------- */
    function initCtas(root) {
      root.addEventListener('click', function (e) {
        var link = e.target.closest('[data-aff-scroll]');
        if (!link) return;
        var id = (link.getAttribute('href') || '').replace(/^.*#/, '');
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var isForm = id === root.dataset.anchor;
        scrollToTarget(target, isForm);
        if (history.replaceState) history.replaceState(history.state, '', '#' + id);
      });

      // Arriving from another page via /pages/affiliate#join
      if (location.hash === '#' + root.dataset.anchor) {
        var target = document.getElementById(root.dataset.anchor);
        window.addEventListener('load', function () { scrollToTarget(target, false); }, { once: true });
      }
    }

    function init(root) {
      if (!root || root.dataset.affReady) return;
      root.dataset.affReady = 'true';
      initCtas(root);
      initStepper(root);
      initForm(root);
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-aff]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eliquid-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DENSITY = { pg: 1.036, vg: 1.261, flav: 1.036, nic: 1.01 };
    var COLORS = { nic: 'var(--elc-nic)', flav: 'var(--elc-accent)', pg: 'var(--elc-pg)', vg: 'var(--elc-vg)' };

    function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
    function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
    function r1(v) { return (Math.round(v * 10) / 10).toFixed(1); }
    function r2(v) { return (Math.round(v * 100) / 100).toFixed(2); }
    function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

    function init(root) {
      if (!root || root.dataset.elcReady) return;
      root.dataset.elcReady = 'true';

      var out = {};
      root.querySelectorAll('[data-elc-out]').forEach(function (el) { out[el.dataset.elcOut] = el; });
      var bars = {};
      root.querySelectorAll('[data-elc-bar]').forEach(function (el) { bars[el.dataset.elcBar] = el; });
      var tabs = root.querySelectorAll('[data-elc-tab]');
      var mode = root.dataset.defaultMode === 'diy' ? 'diy' : 'shortfill';
      var lastRecipeText = '';

      function field(name) {
        var els = root.querySelectorAll('[data-elc-field="' + name + '"]');
        if (!els.length) return null;
        if (els[0].type === 'radio') {
          for (var i = 0; i < els.length; i++) if (els[i].checked) return els[i].value;
          return els[0].value;
        }
        return els[0].value;
      }

      function input(name) { return root.querySelector('[data-elc-field="' + name + '"]'); }

      function setBar(name, pct) { if (bars[name]) bars[name].style.width = clamp(pct, 0, 100) + '%'; }

      function syncChips() {
        root.querySelectorAll('[data-elc-set]').forEach(function (chip) {
          var el = input(chip.dataset.elcSet);
          chip.classList.toggle('is-active', !!el && num(el.value, NaN) === num(chip.dataset.value, NaN));
        });
      }

      function setMode(next) {
        mode = next;
        tabs.forEach(function (t) {
          var on = t.dataset.elcTab === mode;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        root.querySelectorAll('[data-elc-mode]').forEach(function (el) { el.hidden = el.dataset.elcMode !== mode; });
        root.querySelectorAll('[data-elc-result]').forEach(function (el) { el.hidden = el.dataset.elcResult !== mode; });
        update();
      }

      /* ---------- Shortfill ---------- */
      function shortfill() {
        var sf = Math.max(num(field('sfMl'), 50), 1);
        var shotMg = num(field('shotMg'), 18);
        var shotMl = 10;
        var target = clamp(num(field('sfTarget'), 3), 0, shotMg - 0.5);
        var sfVg = num(field('sfVg'), 70);
        var shotVg = 50;

        var strength = function (n) { return (n * shotMl * shotMg) / (sf + n * shotMl); };

        // Exact nic-shot ml for the target, then the closest whole number of shots.
        var exactMl = target > 0 ? (target * sf) / (shotMg - target) : 0;
        var best = Math.round(exactMl / shotMl);
        if (target > 0 && best < 1) best = 1;
        [best - 1, best + 1].forEach(function (n) {
          if (n >= 0 && Math.abs(strength(n) - target) < Math.abs(strength(best) - target)) best = n;
        });

        var maxRow = Math.max(best + 2, 3);
        var rows = '';
        for (var n = 0; n <= maxRow; n++) {
          rows += '<tr' + (n === best ? ' class="is-best"' : '') + '><td>' + n + ' x ' + shotMg + 'mg</td><td>' +
            Math.round(sf + n * shotMl) + 'ml</td><td>' + r1(strength(n)) + 'mg/ml</td></tr>';
        }
        out.sfOptions.innerHTML = rows;

        var total = sf + best * shotMl;
        out.sfHeadline.textContent = best === 0 ? 'No nic shots' : best + (best === 1 ? ' nic shot' : ' nic shots');
        out.sfSub.innerHTML = best === 0
          ? 'Your ' + Math.round(sf) + 'ml shortfill stays nicotine-free (0mg).'
          : best + ' x 10ml ' + shotMg + 'mg shot' + (best === 1 ? '' : 's') + ' = <strong>' + r1(strength(best)) +
            'mg/ml</strong> in ' + Math.round(total) + 'ml';

        // Most shortfill bottles have room for 10ml per 50ml of liquid.
        var room = Math.round(sf / 5);
        out.sfWarn.hidden = best * shotMl <= room;
        out.sfWarn.textContent = 'Heads up: ' + best * shotMl + 'ml of nic shots will not fit in a standard ' + Math.round(sf + room) +
          'ml shortfill bottle. Mix it in a larger empty bottle.';

        out.sfExact.textContent = target > 0
          ? 'For exactly ' + r1(target) + 'mg/ml you would add ' + r1(exactMl) + 'ml of nic shot. Shortfill bottles usually have room for 10ml per 50ml.'
          : '';

        var vg = (sf * sfVg + best * shotMl * shotVg) / total;
        out.sfRatio.textContent = Math.round(vg) + '% VG / ' + (100 - Math.round(vg)) + '% PG';
        setBar('sfVg', vg);
        setBar('sfPg', 100 - vg);
      }

      /* ---------- DIY ---------- */
      function diy() {
        var vol = Math.max(num(field('vol'), 30), 1);
        var vgPct = clamp(num(field('vg'), 70), 0, 100);
        var flavPct = clamp(num(field('flav'), 10), 0, 100);
        var nicMg = num(field('nicMg'), 18);
        var nicVg = num(field('nicVg'), 50) / 100;
        var target = Math.max(num(field('target'), 3), 0);
        var name = (field('name') || '').trim();
        var warn = [];

        var rangeEl = input('vg');
        rangeEl.style.setProperty('--fill', vgPct + '%');
        out.vgLabel.textContent = vgPct + '% VG / ' + (100 - vgPct) + '% PG';

        var flavMl = vol * flavPct / 100;
        var maxTarget = nicMg * (1 - flavPct / 100);
        if (target > maxTarget) {
          warn.push('With ' + nicMg + 'mg shots and ' + flavPct + '% flavour, the strongest you can make is ' + r1(maxTarget) + 'mg/ml. Showing that instead.');
          target = Math.max(maxTarget, 0);
        }

        var nicMl = nicMg > 0 ? (target * vol) / nicMg : 0;
        var fill = Math.max(vol - nicMl - flavMl, 0);

        // PG/VG already supplied by nic shots and (PG-based) flavour
        var vgNeeded = vol * vgPct / 100 - nicMl * nicVg;
        var pgNeeded = vol * (100 - vgPct) / 100 - nicMl * (1 - nicVg) - flavMl;

        var pgMl, vgMl;
        if (pgNeeded < 0) { pgMl = 0; vgMl = fill; }
        else if (vgNeeded < 0) { vgMl = 0; pgMl = fill; }
        else { pgMl = pgNeeded; vgMl = vgNeeded; }

        var actualVg = (vgMl + nicMl * nicVg) / vol * 100;
        if (Math.abs(actualVg - vgPct) > 0.5) {
          warn.push('Your nic shots and flavour already add PG/VG, so the closest ratio you can reach is ' +
            Math.round(actualVg) + '% VG / ' + (100 - Math.round(actualVg)) + '% PG.');
        }

        var parts = [
          { key: 'nic', label: 'Nic shot (' + nicMg + 'mg)', ml: nicMl, d: nicVg * DENSITY.vg + (1 - nicVg) * DENSITY.pg },
          { key: 'flav', label: 'Flavour', ml: flavMl, d: DENSITY.flav },
          { key: 'pg', label: 'PG', ml: pgMl, d: DENSITY.pg },
          { key: 'vg', label: 'VG', ml: vgMl, d: DENSITY.vg }
        ];

        var rows = '';
        var totG = 0;
        var text = [(name || 'E-liquid recipe') + ' - ' + Math.round(vol) + 'ml, ' + r1(target) + 'mg/ml, ' + Math.round(actualVg) + '/' + (100 - Math.round(actualVg)) + ' VG/PG'];
        parts.forEach(function (p) {
          var pct = p.ml / vol * 100;
          setBar(p.key, pct);
          if (p.ml < 0.005 && p.key !== 'pg' && p.key !== 'vg') return;
          var g = p.ml * p.d;
          totG += g;
          rows += '<tr><td><span class="elc__dot" style="background:' + COLORS[p.key] + '"></span>' + esc(p.label) + '</td><td>' +
            r1(p.ml) + '</td><td>' + r2(g) + '</td><td>' + r1(pct) + '</td></tr>';
          text.push(p.label + ': ' + r1(p.ml) + 'ml / ' + r2(g) + 'g (' + r1(pct) + '%)');
        });

        out.diyRows.innerHTML = rows;
        out.totMl.textContent = r1(vol);
        out.totG.textContent = r2(totG);
        out.recipeName.textContent = name || 'Your recipe';
        out.diyHeadline.textContent = r1(target) + 'mg/ml';

        var shots = Math.ceil(nicMl / 10 - 1e-9);
        out.diySub.innerHTML = '<strong>' + Math.round(actualVg) + '/' + (100 - Math.round(actualVg)) + ' VG/PG</strong> &middot; ' + Math.round(vol) + 'ml batch' + (shots > 0
          ? ' &middot; you need <strong>' + shots + ' x 10ml ' + nicMg + 'mg nic shot' + (shots === 1 ? '' : 's') + '</strong>'
          : ' &middot; nicotine-free');

        out.diyWarn.hidden = !warn.length;
        out.diyWarn.textContent = warn.join(' ');
        lastRecipeText = text.join('\n');
      }

      function update() {
        syncChips();
        if (mode === 'diy') diy(); else shortfill();
      }

      /* ---------- Events ---------- */
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { setMode(t.dataset.elcTab); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          var next = mode === 'diy' ? 'shortfill' : 'diy';
          setMode(next);
          root.querySelector('[data-elc-tab="' + next + '"]').focus();
        });
      });

      root.addEventListener('input', update);
      root.addEventListener('change', update);

      root.addEventListener('click', function (e) {
        var step = e.target.closest('[data-elc-step]');
        if (step) {
          var el = step.parentNode.querySelector('input');
          var v = num(el.value, 0) + num(step.dataset.elcStep, 1);
          el.value = clamp(v, num(el.min, 0), num(el.max, 1000));
          update();
          return;
        }
        var chip = e.target.closest('[data-elc-set]');
        if (chip) {
          input(chip.dataset.elcSet).value = chip.dataset.value;
          update();
          return;
        }
        var copy = e.target.closest('[data-elc-copy]');
        if (copy) {
          var done = function () {
            copy.textContent = 'Copied!';
            setTimeout(function () { copy.textContent = 'Copy recipe'; }, 1600);
          };
          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(lastRecipeText).then(done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = lastRecipeText;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); done(); } catch (err) {}
            document.body.removeChild(ta);
          }
        }
      });

      setMode(mode);
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-elc]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-vape-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DAYS_PER_MONTH = 365 / 12;

    var gbp0 = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 });
    var gbp2 = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function num(value, fallback) {
      var n = parseFloat(value);
      return isFinite(n) && n >= 0 ? n : fallback;
    }

    function plural(n, one, many) {
      return n + ' ' + (n === 1 ? one : many);
    }

    function init(root) {
      if (!root || root.dataset.vccReady) return;
      root.dataset.vccReady = 'true';

      var cfg = {
        mlPerCig20: num(root.dataset.mlPerCig20, 0.1),
        mlPerCig10: num(root.dataset.mlPerCig10, 0.2),
        mlPerCoil: num(root.dataset.mlPerCoil, 15) || 15,
        podMl: num(root.dataset.podMl, 2) || 2,
        kitMl: num(root.dataset.kitMl, 12) || 12
      };

      var slider = root.querySelector('[data-vcc-cigs]');
      var sliderOut = root.querySelector('[data-vcc-cigs-out]');
      var results = root.querySelector('.vcc__results');
      var headlineLabel = root.querySelector('[data-vcc-headline-label]');
      var outs = {};
      root.querySelectorAll('[data-vcc-out]').forEach(function (el) { outs[el.dataset.vccOut] = el; });
      var inputs = {};
      root.querySelectorAll('[data-vcc-input]').forEach(function (el) { inputs[el.dataset.vccInput] = el; });
      var bars = {
        smoke: root.querySelector('[data-vcc-bar="smoke"]'),
        vape: root.querySelector('[data-vcc-bar="vape"]')
      };

      // Always show prices as 17.50, not 17.5
      Object.keys(inputs).forEach(function (key) {
        var el = inputs[key];
        el.value = num(el.value, 0).toFixed(2);
        el.addEventListener('blur', function () { el.value = num(el.value, 0).toFixed(2); });
      });

      var shownYear = 0;
      var anim = null;

      function checked(selector, fallback) {
        var el = root.querySelector(selector + ':checked');
        return el ? el.value : fallback;
      }

      function price(key) {
        return inputs[key] ? num(inputs[key].value, 0) : 0;
      }

      function animateBig(target) {
        var el = outs.yearSave;
        var fmt = function (v) { return gbp0.format(Math.round(v)); };
        if (anim) cancelAnimationFrame(anim);
        if (reduceMotion) { el.textContent = fmt(target); shownYear = target; return; }
        var from = shownYear;
        var start = null;
        function tick(t) {
          if (start === null) start = t;
          var p = Math.min((t - start) / 350, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          shownYear = from + (target - from) * eased;
          el.textContent = fmt(shownYear);
          if (p < 1) anim = requestAnimationFrame(tick);
        }
        anim = requestAnimationFrame(tick);
      }

      function update() {
        var cigs = Math.round(num(slider.value, 10));
        var device = checked('[data-vcc-device]', 'refill');
        var nic = checked('[data-vcc-nic]', '20');

        // Slider UI
        var min = num(slider.min, 1);
        var max = num(slider.max, 60);
        slider.style.setProperty('--fill', ((cigs - min) / (max - min)) * 100 + '%');
        sliderOut.textContent = cigs;

        // Show the price fields for the chosen device
        root.querySelectorAll('[data-vcc-prices]').forEach(function (el) {
          el.hidden = el.dataset.vccPrices !== device;
        });

        // --- Smoking ---
        var cigsMonth = cigs * DAYS_PER_MONTH;
        var packsMonth = cigsMonth / 20;
        var smokeMonth = packsMonth * price('pack');

        // --- Vaping ---
        var mlMonth = cigsMonth * (nic === '10' ? cfg.mlPerCig10 : cfg.mlPerCig20);
        var vapeMonth = 0;
        var buy = '';

        if (device === 'refill') {
          var bottles = mlMonth / 10;
          var coils = mlMonth / cfg.mlPerCoil;
          vapeMonth = bottles * price('liquid') + coils * price('coil');
          buy = Math.ceil(bottles) + ' x 10ml ' + (Math.ceil(bottles) === 1 ? 'bottle' : 'bottles') + ' + ' + plural(Math.ceil(coils), 'pod/coil', 'pods/coils');
        } else if (device === 'prefilled') {
          var pods = mlMonth / cfg.podMl;
          vapeMonth = pods * price('pod');
          buy = plural(Math.ceil(pods), 'pod', 'pods') + ' a month';
        } else {
          var kits = mlMonth / cfg.kitMl;
          vapeMonth = kits * price('kit');
          buy = plural(Math.ceil(kits), 'kit', 'kits') + ' a month';
        }

        var saveMonth = smokeMonth - vapeMonth;
        var negative = saveMonth < 0;

        // --- Output ---
        results.classList.toggle('is-negative', negative);
        headlineLabel.textContent = negative ? 'Vaping would cost you more by' : 'You could save around';
        animateBig(Math.abs(saveMonth * 12));
        outs.monthSave.textContent = gbp2.format(Math.abs(saveMonth));
        outs.fiveYear.textContent = gbp0.format(Math.abs(saveMonth * 60));
        outs.smokeMonth.textContent = gbp2.format(smokeMonth);
        outs.vapeMonth.textContent = gbp2.format(vapeMonth);
        outs.packs.textContent = (Math.round(packsMonth * 10) / 10) + ' packs a month';
        outs.ml.textContent = Math.round(mlMonth) + 'ml a month';
        outs.buy.textContent = buy;

        var biggest = Math.max(smokeMonth, vapeMonth, 0.01);
        bars.smoke.style.width = (smokeMonth / biggest) * 100 + '%';
        bars.vape.style.width = Math.max((vapeMonth / biggest) * 100, vapeMonth > 0 ? 2 : 0) + '%';
      }

      root.addEventListener('input', update);
      root.addEventListener('change', update);
      root.querySelectorAll('[data-vcc-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = num(slider.value, 10) + parseInt(btn.dataset.vccStep, 10);
          slider.value = Math.min(num(slider.max, 60), Math.max(num(slider.min, 1), next));
          update();
        });
      });

      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-vcc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
